import NoSleepModule from 'nosleep.js';

// d.ts пакета описывает ESM default, а сам пакет — CJS (module.exports = NoSleep)
const NoSleep = NoSleepModule as unknown as typeof NoSleepModule.default;

/** Ролик NoSleep (mp4 из nosleep.js/src/media.js), отдаётся как обычный файл из public/. */
const KEEP_AWAKE_VIDEO_URL = '/media/keep-awake.mp4';
const KEEP_AWAKE_RETRY_MS = 30_000;

/**
 * webOS: screensaver LG игнорирует Wake Lock API и видео вне DOM —
 * гасится только реально играющим <video> на странице. Держим крошечный
 * почти прозрачный ролик (не display:none — иначе webOS его не считает).
 * Источник — HTTP URL, не data: URI: аппаратный плеер webOS data: не играет.
 * Создаём без проверки UA — встроенный браузер LG не всегда пишет webOS в UA.
 */
function createKeepAliveVideo(): HTMLVideoElement {
  const video = document.createElement('video');
  video.muted = true;
  video.loop = true;
  video.setAttribute('playsinline', '');
  video.setAttribute('aria-hidden', 'true');
  video.style.cssText = 'position:fixed;left:0;top:0;width:2px;height:2px;opacity:0.01;pointer-events:none;z-index:-1;';
  video.src = KEEP_AWAKE_VIDEO_URL;
  video.addEventListener('error', () => {
    console.warn('[WakeLock] keep-alive video error', video.error?.code, video.error?.message);
  });
  document.body.appendChild(video);
  return video;
}

/**
 * Не даёт ТВ уйти в спящий режим / screen saver, пока открыта страница.
 * NoSleep: Wake Lock API (HTTPS) или фолбэк — скрытое зацикленное видео, как у плеера.
 * Дополнительно — видео в DOM (см. createKeepAliveVideo), его перезапускаем,
 * если встало на паузу. Если автозапуск заблокирован — повторяем на первое нажатие пульта / клик.
 */
export function keepScreenAwake(): () => void {
  const noSleep = new NoSleep();
  const video = createKeepAliveVideo();
  const events = ['keydown', 'pointerdown', 'click'] as const;

  const playVideo = () => {
    if (!video.paused) return;
    video.play().then(
      () => console.log('[WakeLock] keep-alive video playing'),
      (err: unknown) => console.warn('[WakeLock] keep-alive video play failed', String(err)),
    );
  };

  const onUserInput = () => {
    if (!noSleep.isEnabled) noSleep.enable().catch(() => undefined);
    playVideo();
  };

  console.log('[WakeLock] start', navigator.userAgent, 'wakeLock' in navigator);
  noSleep.enable().catch(() => undefined);
  playVideo();
  const retryTimer = window.setInterval(playVideo, KEEP_AWAKE_RETRY_MS);
  events.forEach((e) => document.addEventListener(e, onUserInput, true));

  return () => {
    window.clearInterval(retryTimer);
    events.forEach((e) => document.removeEventListener(e, onUserInput, true));
    noSleep.disable();
    video.pause();
    video.remove();
  };
}
